
import axiosInstance from "../../apiAxios/axiosInstance";
export const getPaymentTransactions = async (payload) => {
  const response = await axiosInstance.post("/admin/payment-history", payload);
  return response.data;
};
 



 
